export const SAVE = 'step3.SAVE';
export const VALUE_CHANGED = 'step3.VALUE_CHANGED';
export const LOAD = 'step3.VALUE_LOAD';
export const NEXT = 'step3.NEXT';
export const RESET = 'step3.RESET';
export const RESET_REGISTER_GST_STATE = 'step3.RESET_REGISTER_GST_STATE';
export const CLOSE_BSB_NOTICE = 'step3.CLOSE_BSB_NOTICE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step3/constants.js